module.exports = {
  locales: ["pl", "cz", "de", "es", "fr", "gb", "it", "ro", "se", "sk"],
  defaultLocale: "pl",
  localeDetection: false,
  logBuild: false,
  defaultNS: "main",
  pages: {
    "*": ["main"]
  },
  domains: [
    {
      domain: "dajar.cz",
      defaultLocale: "cz"
    },
    {
      domain: "dajar.de",
      defaultLocale: "de"
    },
    {
      domain: "dajar.es",
      defaultLocale: "es"
    },
    {
      domain: "dajar.fr",
      defaultLocale: "fr"
    },
    {
      domain: "dajar.pl",
      defaultLocale: "pl"
    },
    {
      domain: "dajar.it",
      defaultLocale: "it"
    },
    {
      domain: "dajar.co.uk",
      defaultLocale: "gb"
    },
    {
      domain: "dajar.ro",
      defaultLocale: "ro"
    },
    {
      domain: "dajar.se",
      defaultLocale: "se"
    },
    {
      domain: "dajar.sk",
      defaultLocale: "sk"
    }
  ],
  loader: true,
  loadLocaleFrom: lang =>
    import(`../translations/${lang}.json`).then(m => m.default)
};
